import React, { useCallback, useEffect, useRef, useState } from 'react';

const BotonModo = ({ activo, onClick, children, testId }) => (
  <button type="button" onClick={onClick} data-testid={testId}
    className={`rounded px-2 py-1 text-xs transition-colors ${activo ? 'bg-neutral-900 text-white' : 'bg-neutral-100 text-neutral-700 hover:bg-neutral-200'}`}>
    {children}
  </button>
);

export default function VistaPreviaIframe({ payload, altura = '72vh', titulo = 'Vista previa en vivo', nota, oscuro = false }) {
  const [modo, setModo] = useState('desktop');
  const iframeRef = useRef(null);
  const listo = useRef(false);

  const enviar = useCallback(() => {
    const destino = iframeRef.current?.contentWindow;
    if (destino && listo.current) destino.postMessage({ __jpmPreview: true, ...payload }, window.location.origin);
  }, [payload]);

  useEffect(() => {
    const recibir = (e) => {
      if (e.origin === window.location.origin && e.data?.__jpmPreviewReady && e.source === iframeRef.current?.contentWindow) {
        listo.current = true;
        enviar();
      }
    };
    window.addEventListener('message', recibir);
    return () => window.removeEventListener('message', recibir);
  }, [enviar]);

  useEffect(() => { enviar(); }, [enviar]);

  return (
    <div data-testid="vista-previa">
      <div className="mb-2 flex items-center justify-between">
        <span className={`text-xs font-medium uppercase tracking-wide ${oscuro ? 'text-zinc-400' : 'text-neutral-500'}`}>{titulo}</span>
        <div className="flex gap-1">
          <BotonModo activo={modo === 'desktop'} onClick={() => setModo('desktop')} testId="vista-previa-escritorio">Escritorio</BotonModo>
          <BotonModo activo={modo === 'mobile'} onClick={() => setModo('mobile')} testId="vista-previa-movil">Móvil</BotonModo>
        </div>
      </div>
      <div className="overflow-hidden rounded-xl border border-neutral-200 bg-neutral-50" style={{ height: altura }}>
        <div className={modo === 'mobile' ? 'mx-auto h-full max-w-full' : 'h-full'} style={modo === 'mobile' ? { width: 390 } : undefined}>
          <iframe ref={iframeRef} src="/bodas-preview" title="Vista previa de la página" className="h-full w-full border-0" data-testid="vista-previa-iframe" />
        </div>
      </div>
      {nota && <p className={`mt-2 text-xs ${oscuro ? 'text-zinc-500' : 'text-neutral-400'}`}>{nota}</p>}
    </div>
  );
}
